export default __webpack_public_path__ + "static/new_clients-f473474ed3f513a7645ad706a3b5150a.svg";